<template>
	<div class="editor-main">
		<div id="editor"></div>
	</div>
</template>

<script>
	import Editor from 'wangeditor';
	
	export default {
		name:"dy-wangEditor",
		props:{
			modelValue:{
				type:String,
				default:'',
			},
		},
		watch:{
			modelValue:{
				handler(val) {
					if(val == '') this.editor.txt.html(val);
				}
			},
		},
		data() {
			return {
				editor	: null,
			};
		},
		mounted() {
			this.initEditor();
		},
		methods:{
			initEditor(){
				let editor = new Editor('#editor');
				this.editor = editor;
				editor.config.onchange = html=>{
					this.$emit('update:modelValue', html);
				}
				
				//自义定提示框
				editor.config.customAlert = function (s, t) {
					dyEditor.toast.show(s, t);
				};

				editor.config.uploadImgShowBase64	= false;
				editor.config.uploadImgMaxSize		= 1024 * 1024 * 50;
				editor.config.uploadImgMaxLength 	= 5;
				editor.config.uploadImgTimeout 		= 180 * 1000;	//3分钟
				
				editor.config.customUploadImg = (files, callback)=>{
					uni.showLoading();
					
					files.forEach(file=>{
						file.path = URL.createObjectURL(file);
						editor.disable();
						dyEditor.hotspot.uploadDocImage({
							file,
							error	: res=>{
								uni.hideLoading();
								editor.enable();
							},
							progress : res=>{
							},
							success	: res=>{
								uni.hideLoading();
								editor.enable();
								callback( dyConfig.oss + '/vr/' + dyConfig.id + '/' + res.file);
							}
						});
					})
				}
				
				editor.config.customUploadVideo = (files, callback)=>{
					uni.showLoading();
					
					files.forEach(file=>{
						file.path = URL.createObjectURL(file);
						editor.disable();
						dyEditor.hotspot.uploadDocVideo({
							file,
							error	: res=>{
								uni.hideLoading();
								editor.enable();
							},
							progress : res=>{
							},
							success	: res=>{
								uni.hideLoading();
								editor.enable();
								callback( dyConfig.oss + '/vr/' + dyConfig.id + '/' + res.file);
							}
						});
					})
				}
				
				editor.create();
				editor.txt.html(this.modelValue);
			}
		}
	}
</script>

<style>
	.editor-main{
		width:100%;
		height:100%;
		overflow:hidden;
		box-sizing: border-box;
	}
	#editor,
	#editor >>> .w-e-text-container{
		text-align: left;
		height:calc(100% - 41px) !important;
	}
</style>